import { useState } from "react";

const getDefaultPurchaseInputRow = () => ({
  charge_code: "",
  sac_code: "",
  currency: "",
  rate: "",
  quantity: "",
  taxable_amount: "",
  gst_applicable: "No",
  gst_percent: "",
  gst_amount: "",
  containers: [],
});

const usePurchaseInputRow = (containerOptions, chargeCodeOptions) => {
  const [purchaseInputRows, setPurchaseInputRows] = useState({});

  const getPurchaseInputRow = (vendorIdx) => {
    return purchaseInputRows[vendorIdx] || getDefaultPurchaseInputRow();
  };

  const updatePurchaseInputRow = (vendorIdx, field, value) => {
    setPurchaseInputRows((prev) => {
      const current = prev[vendorIdx] || getDefaultPurchaseInputRow();
      const updated = { ...current, [field]: value };

      // Set GST % to 0 when GST Applicable is "No"
      if (field === "gst_applicable" && value === "No") {
        updated.gst_percent = 0;
        updated.gst_amount = "";
      }

      if (field === "rate" || field === "quantity") {
        const rate =
          field === "rate" ? Number(value) : Number(updated.rate || 0);
        const quantity =
          field === "quantity" ? Number(value) : Number(updated.quantity || 0);
        updated.taxable_amount = (rate * quantity).toString();
        const gstPct = Number(updated.gst_percent) || 0;
        if (updated.gst_applicable === "Yes" && gstPct > 0) {
          updated.gst_amount = ((rate * quantity * gstPct) / 100).toFixed(2);
        }
      }

      if (field === "gst_percent") {
        const taxable = Number(updated.taxable_amount) || 0;
        const gstPct = Number(value) || 0;
        if (updated.gst_applicable === "Yes" && gstPct > 0) {
          updated.gst_amount = ((taxable * gstPct) / 100).toFixed(2);
        } else {
          updated.gst_amount = "";
        }
      }

      return { ...prev, [vendorIdx]: updated };
    });
  };
  
  const addPurchaseChargeRow = (vendorIdx, formik, containerOpts) => {
    const inputRow = getPurchaseInputRow(vendorIdx);
    if (!inputRow.charge_code || !inputRow.currency) {
      return;
    }






    
    // Resolve charge code label from options (inputRow.charge_code stores the option value/ID)
    const chargeOpt = (chargeCodeOptions || []).find(
      (c) => c.value === inputRow.charge_code,
    );
    const chargeCodeLabel = chargeOpt ? chargeOpt.label : inputRow.charge_code;

    const newItem = {
      charge_code: chargeCodeLabel,
      sac_code: inputRow.sac_code,
      currency: inputRow.currency,
      rate: inputRow.rate,
      quantity: inputRow.quantity,
      taxable_amount: inputRow.taxable_amount,
      gst_applicable: inputRow.gst_applicable || "Yes",
      gst_percent: inputRow.gst_percent,
      gst_amount: inputRow.gst_amount,
      containers: (inputRow.containers || [])
        .map((cId) => {
          const found = (containerOpts || containerOptions).find(
            (co) => co.value === cId,
          );
          return found ? found.label : cId;
        })
        .join(", "),
      _isNew: true,
    };

    const updated = [...formik.values.purchases];
    updated[vendorIdx] = {
      ...updated[vendorIdx],
      items: [...(updated[vendorIdx].items || []), newItem],
    };
    formik.setFieldValue("purchases", updated);

    setPurchaseInputRows((prev) => ({
      ...prev,
      [vendorIdx]: getDefaultPurchaseInputRow(),
    }));
  };

  return {
    getPurchaseInputRow,
    updatePurchaseInputRow,
    addPurchaseChargeRow,
  };
};

export default usePurchaseInputRow;
